import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import 'dayjs/locale/it';
import { DefaultSelectedFiltersState, PresenzeModo } from './interface';
import {
  getCookie,
  setCookie,
} from 'packages/blu-booking/src/utility_objects/CookieManager';
import {
  removePointOfSale,
  removeService,
  removeStudio,
  selectPointOfSale,
  selectService,
  selectStudio,
  selectZoomValue,
  setSelectedDate,
  setClient,
  setUser,
} from '../../../utility_objects/StoreFunctions';
import {
  getPresenzeModoSalvato,
  getSoloOrarioSalvato,
  salvaPresenzeModo,
  salvaSoloOrario,
} from '../../../utility_objects/preferenzeCalendario';

const getCurrentView = (view?: string) => {
  if (view) {
    if (view === '3Days') return 'Day';
    else if (view === 'WorkWeek') return 'Week';
    return view;
  }
  const storedView = getCookie('defaultCalendarView') || 'Week';
  if (storedView === '3Days') return 'Day';
  else if (storedView === 'WorkWeek') return 'Week';
  return storedView;
};

const initialState: DefaultSelectedFiltersState = {
  view: getCookie('defaultCalendarView') || 'Week',
  currentView: getCurrentView(),
  selectedDate: new Date(),
  selectedServices: [],
  selectedStudi: [],
  selectedUsers: [],
  zoom: {
    value: 150,
    interval: 60,
    slotCount: 4,
  },
  zoomValue: 150,
  // Scelte del riquadro Visualizzazione di questo calendario, ricordate per
  // PC per un anno nei cookie di sempre (defaultCalendarPresenzeModo,
  // defaultCalendarSoloOrario). Nessuna fascia di default: si vede solo se il
  // PC ha salvato una modalità.
  presenzeModo: getPresenzeModoSalvato('negozio'),
  // «Tutte» di default: la griglia resta 5-24 finché il PC non sceglie
  // «Prenotabili».
  soloOrario: getSoloOrarioSalvato('negozio'),
};

const DefaultCalendarSlice = createSlice({
  name: 'BluBookingDefaultCalendar',
  initialState,
  reducers: {
    DefaultCalendarSetView(
      state: DefaultSelectedFiltersState,
      action: PayloadAction<string>
    ) {
      state.currentView = getCurrentView(action.payload);
      state.view = action.payload;
      setCookie('defaultCalendarView', action.payload);
    },
    DefaultCalendarSetPresenzeModo(
      state: DefaultSelectedFiltersState,
      action: PayloadAction<PresenzeModo>
    ) {
      state.presenzeModo = action.payload;
      salvaPresenzeModo('negozio', action.payload);
    },
    DefaultCalendarSetSoloOrario(
      state: DefaultSelectedFiltersState,
      action: PayloadAction<boolean>
    ) {
      state.soloOrario = action.payload;
      salvaSoloOrario('negozio', action.payload);
    },
    DefaultCalendarSetSelectedDate: setSelectedDate,
    DefaultCalendarSelectZoomValue: selectZoomValue,
    // ? ADD
    DefaultCalendarSelectPointOfSale: selectPointOfSale,
    DefaultCalendarSetService: selectService,
    DefaultCalendarSelectStudio: selectStudio,
    DefaultCalendarSetUser: setUser,
    DefaultCalendarSetClient: setClient,

    // ? REMOVE
    DefaultCalendarRemoveStudio: removeStudio,
    DefaultCalendarRemoveService: removeService,
    DefaultCalendarRemovePointOfSale: removePointOfSale,

    DefaultCalendarResetSelected: (
      state: DefaultSelectedFiltersState,
      action: PayloadAction<string>
    ) => {
      return { ...state, [action.payload]: [] };
    },
    DefaultCalendarReset: () => initialState,
  },
});

export const {
  DefaultCalendarSetView,
  DefaultCalendarSetPresenzeModo,
  DefaultCalendarSetSoloOrario,
  DefaultCalendarSetSelectedDate,
  DefaultCalendarSelectZoomValue,
  DefaultCalendarSelectPointOfSale,
  DefaultCalendarSetService,
  DefaultCalendarSelectStudio,
  DefaultCalendarRemoveStudio,
  DefaultCalendarRemoveService,
  DefaultCalendarRemovePointOfSale,
  DefaultCalendarResetSelected,
  DefaultCalendarSetUser,
  DefaultCalendarSetClient,
  DefaultCalendarReset,
} = DefaultCalendarSlice.actions;

export default DefaultCalendarSlice.reducer;
